export default class pegOtpPage extends HTMLElement {
	connectedCallback() {
		this.abortController = new AbortController();
		this.#trackViewScreen();
	}

	disconnectedCallback() {
		this.abortController.abort();
	}

	#trackViewScreen() {
		jPar.util.log.bigData({
			category: 'adaptive_blocking',
			subcategory: 'otp_verification_screen',
			action: 'screen_view',
		});
	}
}
